export default "__VITE_ASSET__BdAjviZz__"